const computeIsCarInMotion = (carSpeedWhole: number, carSpeedFractional: number) =>
  Number(carSpeedWhole > 0 || carSpeedFractional > 0)

const computeCarSpeed = (carSpeedWhole: number, carSpeedFractional: number) =>
  Number(`${carSpeedWhole}.${carSpeedFractional?.toString()?.padStart(2, '0')}`)

const liftCardComputeFunctions = { computeIsCarInMotion, computeCarSpeed }

export default liftCardComputeFunctions
